import PageMeta from "../components/PageMeta";
import { cityLabel } from "../utils/placeLabels";
import uiI18n from "../i18n";
import React, { useEffect, useState } from 'react';
import { getAllByCity } from '../Services/biensService.jsx';
import SaveSearchPrompt from "../components/SaveSearchPrompt";
 import { useTranslation } from "react-i18next";
 import ListBiens from "../components/ListBiens";
 import {  useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';  

const BiensByCity = () => {
   const { city } = useParams(); 
    const [error, setError] = useState(null);
  // Offered after each search, saved only if the visitor accepts (SaveSearchPrompt).
  const [searchOffer, setSearchOffer] = useState(null);
   const { t } = useTranslation();
   const [biens, setBiens] = useState([]); 
 
  useEffect(() => {
    const fetchBiensByCity = async () => {
      try {
        const allData = await getAllByCity(city);
        setSearchOffer({ kind: 'bien', city });
         setBiens(allData);
      } catch (error) {
        setError(error.message);
      }
    };

    if (city) {
      fetchBiensByCity();
    }
  }, [city]);

  if (error) {
    return <div>{uiI18n.t("ui.error_268")} {error}</div>;
  }

  return (
    <div>
      <PageMeta titleKey="seo.city" values={{ city: cityLabel(city) }} path={'/BiensByCity/' + encodeURIComponent(city || '')} />
      <SaveSearchPrompt search={searchOffer} />
      {biens.length === 0 ? (
        <p>{t('listing.noData')}</p>
      ) : (
        <ul className="sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
         <p></p>
            {biens.map((bien) => (
              <ListBiens 
                key={bien.ID} 
                listing={bien}  
              />
            ))} 
         
        </ul>
      )}
    </div>
  );
};

export default BiensByCity;
